import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import Popover from "../../../Display/Popover/Popover";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function StatusToolTip(_ref) {
  let {
    description,
    toolTip,
    programId,
    className
  } = _ref;
  const [showPopover, togglePopover] = useReducer(state => !state, false);
  return /*#__PURE__*/_jsxs("div", {
    className: "uu-search__popover-".concat(description, "-container flex"),
    style: {
      display: 'unset'
    },
    children: [/*#__PURE__*/_jsxs("button", {
      id: "tool-tip-button-".concat(programId.replace(/[^a-zA-Z0-9]/g, '-')),
      type: "button",
      className: className,
      children: [/*#__PURE__*/_jsx(Icon, {
        icon: "QuestionCircleO",
        className: "fill-current text-current-blue"
      }), /*#__PURE__*/_jsx("span", {
        className: "sr-only",
        children: description
      })]
    }), /*#__PURE__*/_jsx(Popover, {
      className: "uu-search__popover-".concat(description, " pointer-events-none"),
      target: "tool-tip-button-".concat(programId.replace(/[^a-zA-Z0-9]/g, '-')),
      isOpen: showPopover,
      toggle: togglePopover,
      placement: "bottom",
      body: toolTip,
      fade: true
    })]
  });
}
StatusToolTip.propTypes = {
  description: PropTypes.string.isRequired,
  toolTip: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  className: PropTypes.string
};
StatusToolTip.defaultProps = {
  className: null
};
export default StatusToolTip;
//# sourceMappingURL=StatusToolTip.js.map